import { render } from "./ui-select.vue?vue&type=template&id=cca059d4&scoped=true&ts=true"
import script from "./ui-select.vue?vue&type=script&lang=ts"
export * from "./ui-select.vue?vue&type=script&lang=ts"

import "./ui-select.vue?vue&type=style&index=0&id=cca059d4&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca059d4"]])

export default __exports__